import { SampleServiceModelBase } from "./base/sample-service-model-base";

export class ContactUsSM extends SampleServiceModelBase<number>{
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    contactNumber!: number;
    contactMessage: string = '';
}